import classNames from 'classnames';
import React from 'react';

type AsProp<T extends React.ElementType> = {
  as?: T;
};

type ComponentProps<T extends React.ElementType> = AsProp<T> &
  Omit<React.ComponentPropsWithoutRef<T>, keyof AsProp<T>>;

export const Container = <T extends React.ElementType = 'div'>({
  as,
  children,
  className,
  ...props
}: ComponentProps<T> & { children?: React.ReactNode }) => {
  const TagElement = as || 'div';

  return (
    <TagElement className={classNames('px-4', className)} {...props}>
      {children}
    </TagElement>
  );
};
